import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getLanguageDetails } from "../../../../redux/actions/campaignActions";
import Sidebar from "../../../../components/sidebar/Sidebar";
import Navbar from "../../../../components/navbar/Navbar";
import Loader from "../../../../components/Loader/Loader";
import "../../../../components/common/css/new.scss";
import "../../../../components/common/css/add.scss";

const LanguageView = () => {
  let token = localStorage.getItem("accessToken");
  const [loading, setLoading] = useState(false);
  const id = useParams();
  const dispatch = useDispatch();
  const languageView = useSelector((state) => state.languageView);
  const { language } = languageView;

  useEffect(() => {
    dispatch(getLanguageDetails(token, id));
  }, [dispatch]);

  useEffect(() => {
    if (languageView) {
      if (languageView?.loading !== undefined) {
        setLoading(languageView?.loading);
      }
    }
  }, [languageView]);

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <Loader isLoading={loading} />
        <div className="bottom">
          <div className="modal-content">
            <div className="modal-content-title">View Content</div>
            <p>&nbsp;</p>
            <form>
              <div className="custome-form-group">
                <label>Page Section</label>
                <input
                  type="text"
                  name="name"
                  value={language?.data?.section}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>Key</label>
                <input
                  type="text"
                  name="name"
                  value={language?.data?.key}
                  disabled={true}
                  placeholder="Enter Category Name"
                  className="custome-input"
                />
              </div>
              <div className="custome-form-group">
                <label>English Content</label>
                <CKEditor
                  editor={ClassicEditor}
                  data={language?.data?.english}
                  name="aboutcontent"
                />
              </div>
              <div className="custome-form-group">
                <label>French Content </label>
                <CKEditor
                  editor={ClassicEditor}
                  data={language?.data?.french}
                  name="aboutcontent"
                />
              </div>
              <button type="submit" className="approveButton">
                Save
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LanguageView;
